<template>
    <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center class="heading">Programma {{year}}</center>
                        </div>
                    </div>
                </div>
            </div>

      </section>
      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container-fluid" style="width: 70vw">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5" v-if="!isMobile()">
                              <div class="d-none d-lg-block d-xl-block">
                                <div class="row row-grid">
                                  <div v-bind:class="'col-lg-' + leftOffset"></div>
                                  <div v-bind:class="'col-lg-' + cardWidth" v-for="room in rooms">
                                    <center>
                                      <h6>{{room}}</h6>
                                    </center>
                                  </div>
                                  <div v-bind:class="'col-lg-' + rightOffset"></div>
                                </div>
                              </div>
                              <div class="gridbox d-none d-lg-block d-xl-block">
                                <div class="gridline" v-for="line in gridlines"></div>
                              </div>
                              <div class="row row-grid">
                                <div v-bind:class="'col-lg-' + leftOffset"></div>
                                <div v-bind:class="'lane col-lg-' + cardWidth" v-for="room in rooms">
                                  <div  class="room"
                                        v-bind:class="event.class" v-if="event != 0"
                                        v-bind:style="'height:' +event.height+ 'px;'"
                                        @click="openConditional(event)"
                                        v-for="event in events[room]">
                                    <div style="float: left; font-size: 15px;" v-if="!event.spacer">{{event.room}}</div>
                                    <div style="float: right;" class="pull-right" v-if="!event.spacer">
                                      <span style="font-size: 10px;">{{event.start}} - {{event.end}}</span>
                                    </div>
                                    <div class="title" style="font-size: 16px; padding-top: 20px;" v-if="!event.spacer"><b>{{event.title}}</b></div>
                                    <div class="speaker" v-if="!event.spacer">{{event.speaker}}</div>
                                  </div>
                                </div>
                                <div v-bind:class="'col-lg-' + rightOffset"></div>
                              </div>
                            </card>
                            <card class="border-0" shadow body-classes="py-5" v-else>
                              <div class="row row-grid">
                                <div  class="room"
                                      v-bind:class="event.class" v-if="event != 0"
                                      v-bind:style="'height:' +event.height+ 'px;'"
                                      @click="openConditional(event)"
                                      v-for="event in eventlist">
                                  <div style="font-size: 15px;" v-if="!event.spacer">{{event.room}}</div>
                                  <div class="pull-right" v-if="!event.spacer">
                                    <span style="font-size: 10px;">{{event.start}} - {{event.end}}</span>
                                  </div>
                                  <div class="title" style="padding-top: 10px;" v-if="!event.spacer">{{event.title}}</div>
                                  <div class="speaker" v-if="!event.spacer">{{event.speaker}}</div>
                                </div>
                              </div>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>

      <!-- Modal -->
      <modal :show.sync="info">
       <template slot="header">
          <h5 class="modal-title">{{talk.title}}</h5>
       </template>
       <div>
         <small>{{talk.speaker}} <span class="pull-right">{{talk.start}} - {{talk.end}}</span></small>
         <div v-html="talk.summary"></div>
         <img v-bind:src="talk.picture" width="100%"/>
       </div>
     </modal>

    </div>
</template>

<script>
import ProgrammaData from "@/data/ProgrammaData.js";
import Modal from "@/components/Modal.vue";
import variables from "../variables.js";

export default {
  components: {
    Modal
  },
  data(){
    return {
      year: 0,
      info: false,
      leftOffset: 0,
      rooms: [],
      rightOffset: 0,
      gridlines: [],
      events: {},
      eventlist: [],
      talk: {}
    }
  },
  watch: {
    info: function (val) {
      if (val === false) {
        history.pushState(
          {},
          null,
          "/programma/" + this.year
        );
      }
    }
  },
  mounted(){
    if (this.$route.params.year){
      this.year = this.$route.params.year;
    } else {
      this.year = variables.getVariable("programma");
    }
    var data = ProgrammaData.load(this.year).then(response => {
      this.talks = response.data;
      this.prepare(response.data);
      if (this.$route.params.id){
        this.open(this.$route.params.id);
      }
    });
  },
  methods: {
    openConditional(event){
      if (!event.spacer){
        this.open(event.index);
      }
    },
    open(index){
      history.pushState(
        {},
        null,
        "/programma/" + this.year + "/" + index
      );
      this.talk = this.talks[index];
      this.info = true;
    },
    isMobile() {
       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
       } else {
         return false
       }
     },
    prepare(data){
      // Find rooms
      var rooms = data.map(event => event.room);
      this.rooms = rooms.filter(onlyUnique);

      // Prepare offset
      var numRooms = this.rooms.length;
      this.cardWidth = Math.floor(12/numRooms);
      this.leftOffset =  Math.floor((12 - (this.cardWidth*numRooms))/2);
      this.rightOffset =  Math.ceil((12 - (this.cardWidth*numRooms))/2);

      if (!this.isMobile()){
        // Prepare desktop grid
        this.events = {};
        this.gridlinePrep = this.rooms.map(room => 0);
        this.rooms.forEach(room => {
          this.events[room] = [];
          const index = this.rooms.indexOf(room);
          data.forEach(event => {
            if (room == event.room){
              event.empty = false;
              event.index = this.talks.indexOf(event);
              event.class = event.spacer ? 'spacer d-none d-lg-block d-xl-block': getRoomClass(index);
              event.height = 110 * Math.round(event.duration/15);
              this.events[room].push(event);
              this.gridlinePrep[index] += event.duration;
            }
          });
        });

        // Prepare gridlines
        var totalDuration = Math.max.apply(Math, this.gridlinePrep);
        this.gridlines = new Array(Math.round(totalDuration/15));
      } else {
        // prepare mobile list
        data.forEach(event => {
          if (!event.spacer){
            event.empty = false;
            event.index = this.talks.indexOf(event);
            event.class = getRoomClass(this.rooms.indexOf(event.room));
            event.height = 200;
            this.eventlist.push(event);
          }
        });
      }
    }
  }
}

function onlyUnique(value,index,self){
  return self.indexOf(value) === index;
}

function getRoomClass(index){
  var classes = ["one","two","three","four","five"];
  return classes[index%5];
}
</script>

<style>
.lane {
  padding: 5px !important;
}
.gridbox {
  z-index: 0;
  position: absolute;
  width: 100%;
  padding-right: 3vw;
}
.gridline {
   border-top: 1px solid;
   border-color: rgba(0, 0, 0, 0.1);
   height: 110px;
   width: 100%;
}
.heading {
  color: white;
  font-size:80px !important;
}

.room {
    opacity: 1;
    width: 100%;
    border-style: solid;
    border-color: white;
    border-radius: 1px;
    border-width: 1px;
    padding: 10px;
    margin: 0px;
}

.room:hover {
    opacity: .85;
    transition: opacity .2s ease-out;
    -moz-transition: opacity .2s ease-out;
    -webkit-transition: opacity .2s ease-out;
    -o-transition: opacity .2s ease-out;
}

.spacer {
    opacity: .0;
}

.spacer:hover {
    opacity: .0;
}

.one {
    background-color: #a4cbf2;
}

.two {
    background-color: rgba(191, 191, 191, .5);
}

.three {
    background-color: #f2f2a4;
}

.four {
    background-color: #a4a4f2;
}

.five {
    background-color: #f2a4a4;
}

.title {
    font-size: 120%;
    margin-top: 15px;
}

.speaker {
    font-size: 80%;
}

@media (max-width: 500px) {
    .title {
        font-size: 100%;
        margin-top: 10px;
    }

    .speaker {
        font-size: 80%;
    }

    .time-slot {
        position: absolute;
        right: 20px;
        font-size: 80%;
    }
}

</style>
